<template>
  <div class="timetablewrapper">
    <div class="container eventdefinitions">
      <h2>Joulun tapahtumat</h2>
      <div v-if="loading" class="loading">
        <BouncingLoader />
      </div>
      <div v-if="error" class="error">{{ error }}</div>
      <div v-if="loaded" class="calendar-data">
        <div
          class="eventdefinition"
          v-for="(event, i) in loaded.filter(event => !event.extension)"
          :key="'event-define-'+i+'-'+event.name"
        >
          <div class="eventdefinitionwrapper">
            <Event
              :name="event.name"
              :gridRow="event.gridRow"
              :gridColumn="event.gridColumn"
              :color="event.color"
              :backgroundColor="event.backgroundColor"
              :textColor="event.textColor"
              :align="event.align"
              :wrapsFrom="event.wrapsFrom"
              :singleDayEvent="event.singleDayEvent"
              :eventClass="event.eventClass"
              :definition="true"
            />
            <span class="definitiondate">{{event.humanReadableDate}}</span>
          </div>
          <div class="eventdescription">
            <p>{{event.description}}</p>
          </div>
          <div class="timedEvents" v-if="event.events">
            <div
              class="timedEvent"
              v-for="timedEvent in event.events"
              :key="timedEvent.name+timedEvent.time"
            >
              <div class="timedEventHead">
                <span class="timedEventTime">{{timedEvent.time}}</span>
                <span class="timedEventName">{{timedEvent.name}}</span>
              </div>
              <div class="timedEventBody">
                <span class="timedEventDescription">{{timedEvent.description}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Event from "@/components/TimetableEvent.vue";

export default {
  name: "Timetable",
  components: {
    Event
  },
  data() {
    return {
      loading: false,
      loaded: null,
      error: null,
      doorsLeft: null,
      defaultCalendarYear: 2019,
      defaultCalendarMonth: 12,
      eventData: [
        {
          name: "Joulukalenterin ensimmäinen luukku",
          description: "Karanteenin joulukalenteri aukeaa",
          humanReadableDate: "Sunnuntai 1.12.2019",
          eventClass: "blue",
          singleDayEvent: true
        },
        {
          name: "Joulujuhlat",
          description:
            "Karanteenin joulun päätapahtumapäivä. Päivään sisältyy monia tapahtumia, kisoja ja palkintoja.",
          humanReadableDate: "Lauantai 21.12.2019",
          eventClass: "green",
          singleDayEvent: true,
          events: [
            {
              time: "14:00",
              name: "Lumisota",
              description: "Paintballin tapaista lumisotaa"
            },
            {
              time: "16:00",
              name: "Venekisa",
              description: "Kilpaveneilyä jäisellä talviradalla"
            },
            {
              time: "18:00",
              name: "Lahjojen keräys",
              description: "Lahjojen etsimistä kilpaa"
            },
            {
              time: "20:00",
              name: "Piirtokilpailu",
              description:
                "Piirtokilpailu netissä; aiheina ovat jouluiset asiat"
            },
            {
              time: "21:00",
              name: "Juhlien lopetus",
              description: "Palkintojen jako ja juhlien lopetus"
            }
          ]
        },
        {
          name: "Joulukalenteri sulkeutuu",
          description:
            "Joulukalenteri sulkeutuu. Tämän päivän jälkeen Karanteenin joulukalenterin luukkuja ei voi enää avata.",
          humanReadableDate: "Lauantai 28.12.2019",
          eventClass: "red",
          singleDayEvent: true
        }
      ]
    };
  },
  props: {},
  methods: {
    setEvents() {
      this.error = null;
      this.loading = true;

      try {
        this.loading = false;
        this.loaded = this.eventData;
      } catch (err) {
        this.error = err;
        this.loading = false;
        this.loaded = null;
      }
    }
  },
  computed: {},
  created() {
    this.setEvents();
  }
};
</script>

<style scoped>
.timetablewrapper {
  padding: 3em calc(0.6em + 4vw);
  background-color: hsla(222, 45%, 97%, 1);
  box-shadow: inset 0px 2px 5px 0 rgba(0, 0, 0, 0.1),
    inset 0px -2px 5px -5px rgba(0, 0, 0, 0.56);
  margin-bottom: 5em;
}

.warning {
  color: hsl(9, 67%, 48%);
}

.timetable {
  margin: auto;
  border-radius: 10px;
  background: #fff;
  max-width: 1150px;
  box-shadow: 0 2px 3px 0px rgba(0, 0, 0, 0.16);
}

.timetablehead {
  padding: 1.4em;
  padding-bottom: 1em;
}

.timetablehead > h2 {
  margin: 0;
}

.days {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(7, minmax(120px, 1fr));
  grid-template-rows: 3.1em;
  grid-auto-rows: 115px;
  overflow: auto;
}

.dayname {
  text-transform: uppercase;
  color: hsl(208, 3%, 28%);
  font-size: 1.6em;
  font-weight: 700;
  padding: 0;
  border-bottom: 1px solid #bc4d5a;
  display: flex;
  justify-content: center;
  align-items: center;
}

.example-event {
  height: 13px;
  width: 24px;
  display: inline-block;
  border-radius: 4px;
  margin: 0 0.2em;
  flex: 0 0 auto;
}

.examplecontainer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0.45em;
  padding-left: 0.7em;
  border-bottom: 1px solid #ebebeb;
}

.examplecontainer:last-of-type {
  border-bottom: none;
}

.examplecontainer > span {
  margin-left: 0.3em;
  margin-right: 0.1em;
  text-align: left;
}

.eventdefinitions {
  max-width: none;
  margin: auto;
  max-width: 1150px;
  margin-top: 2.6em;
  padding: unset;
  margin-bottom: 2em;
  background-color: rgb(255, 255, 255);
  padding-top: 1.4em;
  box-shadow: 0 2px 3px 0px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
}

.eventdefinitions h2 {
  margin: 0;
}

.eventdefinition {
  display: flex;
  align-items: start;
  flex-direction: column;
  border-bottom: 1px solid #dbdbdb;
  padding: 1em;
}

.eventdefinition:first-of-type {
  margin-top: 2.4em;
}

.eventdefinition:last-of-type {
  border-bottom: none;
  border-radius: 0 0 10px 10px;
}

.definitiondate {
  margin: 0 0.5em;
  font-weight: 600;
  color: #111111;
  letter-spacing: 0.5px;
}

.eventdefinitionwrapper {
  flex-basis: 40%;
  display: flex;
  align-items: center;
  margin-bottom: 0.5em;
}

.eventdescription {
  flex-basis: 60%;
}

.eventdescription p {
  font-size: 1.1em;
  margin: 0;
  font-weight: 300;
}

.timedEvents {
  margin-top: 0.5em;
  margin-left: 1em;
}

.timedEvent {
  margin-bottom: 0.2em;
  display: flex;
  justify-content: flex-start;
}


.timedEventHead {
  margin-right: 3px;
  width: 12em;
  text-align: left;
}

.timedEventBody {
      text-align: left;
}

.timedEventDescription {
  text-align: left;
  display: inline-block;
}

.timedEventName {
      font-weight: 600;
}

.timedEventTime {
  width: 3.3em;
  display: inline-block;
  font-weight: 200;
}

@media screen and (max-width: 800px) {
  .eventdefinitionwrapper {
    flex-direction: column;
    align-items: flex-start;
  }

  .timedEvent {
    flex-direction: column;
    margin-bottom: 0.4em;
  }

  .definitiondate {
    margin: 0;
    margin-top: 0.3em;
  }
}
</style>
